var render = function () {
  var _vm$resume, _vm$resume$profile, _vm$resume2, _vm$resume2$profile, _vm$resume3, _vm$resume3$personalI, _vm$resume4, _vm$resume4$personalI, _vm$resume5, _vm$resume5$personalI, _vm$employment, _vm$employment$place, _vm$employment2, _vm$employment2$place, _vm$value, _vm$value$form, _vm$value2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-20"
  }, [_c('v-card', {
    staticStyle: {
      "overflow": "unset"
    },
    attrs: {
      "rounded": "lg",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-24"
  }, [_c('v-row', {
    staticClass: "row--x-large",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": true,
      "hide-details": ""
    },
    on: {
      "change": function change($event) {
        return _vm.$emit('select', _vm.value);
      }
    },
    model: {
      value: _vm.isSelected,
      callback: function callback($$v) {
        _vm.isSelected = $$v;
      },
      expression: "isSelected"
    }
  })], 1), _c('v-col', {
    staticClass: "worker-item__left",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "grey"
    }
  }, [_c('v-img', {
    attrs: {
      "src": (_vm$resume = _vm.resume) === null || _vm$resume === void 0 ? void 0 : (_vm$resume$profile = _vm$resume.profile) === null || _vm$resume$profile === void 0 ? void 0 : _vm$resume$profile.url,
      "aspect-ratio": "1 / 1"
    }
  }, [_c('v-fade-transition', [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !((_vm$resume2 = _vm.resume) !== null && _vm$resume2 !== void 0 && (_vm$resume2$profile = _vm$resume2.profile) !== null && _vm$resume2$profile !== void 0 && _vm$resume2$profile.url),
      expression: "!resume?.profile?.url"
    }]
  }, [_vm._v("mdi-account")])], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h5', {
    staticClass: "page-text--lg font-weight-medium pr-4 pr-lg-0 min-w-lg-80px"
  }, [_vm._v(" " + _vm._s((_vm$resume3 = _vm.resume) === null || _vm$resume3 === void 0 ? void 0 : (_vm$resume3$personalI = _vm$resume3.personalInformation) === null || _vm$resume3$personalI === void 0 ? void 0 : _vm$resume3$personalI.name) + " ")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text grey-9--text"
  }, [_vm._v(" (" + _vm._s((_vm$resume4 = _vm.resume) === null || _vm$resume4 === void 0 ? void 0 : (_vm$resume4$personalI = _vm$resume4.personalInformation) === null || _vm$resume4$personalI === void 0 ? void 0 : _vm$resume4$personalI.genderText) + ", " + _vm._s((_vm$resume5 = _vm.resume) === null || _vm$resume5 === void 0 ? void 0 : (_vm$resume5$personalI = _vm$resume5.personalInformation) === null || _vm$resume5$personalI === void 0 ? void 0 : _vm$resume5$personalI.age) + ") ")])])], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "worker-item__head-center",
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('ul', {
    staticClass: "dot-texts"
  }, _vm._l(_vm.cardTextList(), function (text) {
    return _c('li', {
      key: text,
      staticClass: "dot-text page-text grey-6--text ellip"
    }, [_vm._v(" · " + _vm._s(text) + " ")]);
  }), 0)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "4",
      "lg": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.$refs['application-view'].shows = true;
      }
    }
  }, [_vm._v("지원자 정보")])], 1), _c('v-col', {
    attrs: {
      "cols": "4",
      "lg": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "block": "",
      "color": "secondary",
      "disabled": ((_vm$employment = _vm.employment) === null || _vm$employment === void 0 ? void 0 : (_vm$employment$place = _vm$employment.place) === null || _vm$employment$place === void 0 ? void 0 : _vm$employment$place.title) === '해당없음'
    },
    on: {
      "click": _vm.showCompanyStatus
    }
  }, [_vm._v(" 근무지 현황 ")])], 1), _c('v-col', {
    attrs: {
      "cols": "4",
      "lg": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": "",
      "block": "",
      "color": "secondary",
      "disabled": ((_vm$employment2 = _vm.employment) === null || _vm$employment2 === void 0 ? void 0 : (_vm$employment2$place = _vm$employment2.place) === null || _vm$employment2$place === void 0 ? void 0 : _vm$employment2$place.title) === '해당없음'
    },
    on: {
      "click": _vm.showPersonalStatus
    }
  }, [_vm._v(" 개인 근무 현황 ")])], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-10 mt-lg-16 mb-12 mb-lg-24",
    attrs: {
      "rounded": "",
      "flat": "",
      "color": "grey-f7"
    }
  }, [_c('div', {
    staticClass: "pa-12 px-md-16 py-md-8"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "page-text primary--text",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('strong', [_vm._v("계약서")])]), _c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('p', [_vm._v(" " + _vm._s((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$form = _vm$value.form) === null || _vm$value$form === void 0 ? void 0 : _vm$value$form.name) + " ")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('p', {
    staticClass: "secondary--text"
  }, [_vm._v(_vm._s((_vm$value2 = _vm.value) !== null && _vm$value2 !== void 0 && _vm$value2.isSigned ? "서명 완료" : "서명 미완료"))])])], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('worker-form', {
    attrs: {
      "value": _vm.value
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "block": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("자세히 보기")])];
      }
    }])
  })], 1)], 1)], 1)]), _c('v-row', {
    staticClass: "ma-n6"
  }, [_c('v-col', {
    staticClass: "pa-6",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text font-weight-medium min-w-md-100px mt-md-6 mt-lg-8"
  }, [_vm._v("근무지")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-select', _vm._b({
    attrs: {
      "items": _vm.places,
      "item-text": "title",
      "itme-value": "places",
      "return-object": ""
    },
    model: {
      value: _vm.employment.place,
      callback: function callback($$v) {
        _vm.$set(_vm.employment, "place", $$v);
      },
      expression: "employment.place"
    }
  }, 'v-select', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('deleteContract', _vm.value._id);
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("삭제")])])], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-6",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text font-weight-medium min-w-md-100px mt-md-6 mt-lg-8"
  }, [_vm._v("근로 계약 기간")])]), _c('v-col', [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-date-field', _vm._b({
    staticClass: "mw-lg-170px",
    attrs: {
      "attach": false,
      "textFieldClass": "v-input--small",
      "disabled": _vm.employment.date.fixedCheck
    },
    model: {
      value: _vm.employment.date.startsAt,
      callback: function callback($$v) {
        _vm.$set(_vm.employment.date, "startsAt", $$v);
      },
      expression: "employment.date.startsAt"
    }
  }, 'v-date-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text page-text--sm"
  }, [_vm._v("~")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": ""
    }
  }, [_c('v-date-field', _vm._b({
    staticClass: "mw-lg-170px",
    attrs: {
      "attach": false,
      "textFieldClass": "v-input--small",
      "disabled": _vm.employment.date.fixedCheck
    },
    model: {
      value: _vm.employment.date.endsAt,
      callback: function callback($$v) {
        _vm.$set(_vm.employment.date, "endsAt", $$v);
      },
      expression: "employment.date.endsAt"
    }
  }, 'v-date-field', _vm.attrs_input, false))], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-checkbox', {
    staticClass: "v-input--checkbox--lg",
    attrs: {
      "hide-details": "",
      "label": "근로 기간의 정함이 없음"
    },
    model: {
      value: _vm.employment.date.fixedCheck,
      callback: function callback($$v) {
        _vm.$set(_vm.employment.date, "fixedCheck", $$v);
      },
      expression: "employment.date.fixedCheck"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-6",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text font-weight-medium min-w-md-100px mt-md-6 mt-lg-8"
  }, [_vm._v("근로 시간")])]), _c('v-col', [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-time-field', _vm._b({
    staticClass: "mw-lg-170px",
    attrs: {
      "attach": false,
      "textFieldClass": "v-input--small",
      "disabled": _vm.employment.hour.fixedCheck
    },
    model: {
      value: _vm.employment.hour.startsAt,
      callback: function callback($$v) {
        _vm.$set(_vm.employment.hour, "startsAt", $$v);
      },
      expression: "employment.hour.startsAt"
    }
  }, 'v-time-field', _vm.attrs_input, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text page-text--sm"
  }, [_vm._v("~")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": ""
    }
  }, [_c('v-time-field', _vm._b({
    staticClass: "mw-lg-170px",
    attrs: {
      "attach": false,
      "textFieldClass": "v-input--small",
      "disabled": _vm.employment.hour.fixedCheck
    },
    model: {
      value: _vm.employment.hour.endsAt,
      callback: function callback($$v) {
        _vm.$set(_vm.employment.hour, "endsAt", $$v);
      },
      expression: "employment.hour.endsAt"
    }
  }, 'v-time-field', _vm.attrs_input, false))], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "xl": "auto"
    }
  }, [_c('v-checkbox', {
    staticClass: "v-input--checkbox--lg",
    attrs: {
      "hide-details": "",
      "label": "근로 기간의 정함이 없음"
    },
    model: {
      value: _vm.employment.hour.fixedCheck,
      callback: function callback($$v) {
        _vm.$set(_vm.employment.hour, "fixedCheck", $$v);
      },
      expression: "employment.hour.fixedCheck"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('application-view', _vm._b({
    ref: "application-view",
    on: {
      "input": function input(item) {
        return _vm.$emit('input', item);
      }
    }
  }, 'application-view', {
    'value': _vm.value.application,
    recruitment: _vm.recruitment
  }, false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }